import { DropDrownValueType, TableDataType } from '../model/partner-pool-check.model';
import { GlnData, PartnerPoolCompanySearchMatch } from '../model/platform-request.model';

export const MOCK_GLN_OPTIONS: DropDrownValueType[] = [
  {
    value: 'BAYARD_0',
    representation: 'Verified by BAYARD | 1 results',
    disabled: false,
  },
];

export const MOCK_PARTNER_POOL_OPTIONS: DropDrownValueType[] = [
  {
    value: 'Quinta do javali, LDA_0',
    representation: 'Partnerpool 0 | Matching Score: 82%',
    disabled: false,
  },
  {
    value: 'Piriquita_1',
    representation: 'Partnerpool 1 | Matching Score: 83%',
    disabled: false,
  },
];

export const MOCK_PARTNER_POOL_DROPDOWN: TableDataType[] = [
  {
    key: 'Test Organization 1_0',
    markantId: null,
    name: 'Test Organization 1',
    address: 'Teststr. 16',
    postalCode: '12344',
    city: 'Testcity',
    countryCode: 'DE',
    goldenRecord: false,
    matchScore: 0.9331514324693042,
    streetNumber: null,
    gln: '',
    commercialRegisterId: '',
    taxData: '12313123',
  },
];

export const MOCK_GLN_DROPDOWN: TableDataType[] = [
  {
    key: 'BAYARD_0',
    markantId: null,
    name: 'org BAYARD',
    address: 'Rua ali ao lado',
    streetNumber: '123',
    postalCode: '12345',
    city: 'Offenburg',
    countryCode: 'DE',
    goldenRecord: null,
    matchScore: null,
    gln: '9419161081314',
    commercialRegisterId: null,
    taxData: null,
  },
];

export const MOCK_GLN_DATA: GlnData[] = [
  {
    dataSource: 'BAYARD',
    organizationName: 'org BAYARD',
    gln: '9419161081314',
    address: 'Rua ali ao lado',
    street: 'Rua x',
    streetNumber: '123',
    city: 'Offenburg',
    postalCode: '12345',
    country: 'DE',
  },
];

export const MOCK_DATA_PARTNER_POOL: PartnerPoolCompanySearchMatch[] = [
  {
    markantId: null,
    name: 'Test Organization 1',
    address: 'Teststr. 16',
    postalCode: '12344',
    city: 'Testcity',
    countryCode: 'DE',
    goldenRecord: false,
    matchScore: 0.9331514324693042,
    streetNumber: null,
    gln: '',
    commercialRegisterId: '',
    salesTaxId: null,
    taxNumber: '12313123',
  },
];
